"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalEventTracker = void 0;

var _trk = require("./trk");

var _trackEvent = require("./trackEvent");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * tracks events from clicks on elements with data-trk attributes
 *
 * @param {*} e
 */
var globalEventTracker = function globalEventTracker(e) {
  var target = null;

  if (e.target) {
    target = e.target;
  } else if (e.currentTarget) {
    target = e.currentTarget;
  }

  if (target) {
    var trkEventStr = target.getAttribute('data-trk');
    var action = target.getAttribute('data-trk-act');
    var label = target.getAttribute('data-trk-lbl');
    var ignore = target.getAttribute('data-trk-ign'); // auto track links and buttons

    if (!action) {
      if (target.className.includes("Button")) {
        action = target.innerText + " Pressed";
        console.log("Auto Tracked Button", action);
      } else if (target.tagName === 'A') {
        action = target.innerText + " Pressed";
        console.log("Auto Tracked Link", action);
      }
    }

    if (ignore) {
      return;
    }

    if (trkEventStr) {
      (0, _trk.trk)(trkEventStr, false);
    } else if (action) {
      console.log("globalEventTracker", action, target);
      (0, _trackEvent.trackEvent)({
        action: action,
        label: label,
        element: target
      });
    } // check parent
    else if (target.parentElement && target.parentElement.getAttribute) {
      globalEventTracker({
        target: target.parentElement
      });
    }
  }
};

exports.globalEventTracker = globalEventTracker;